module.exports = "/_next/static/images/btc-92637b00dedd7b568760c7b810830d28.png";